import { render, staticRenderFns } from "./Chart-js.vue?vue&type=template&id=616ad254&"
import script from "./Chart-js.vue?vue&type=script&lang=js&"
export * from "./Chart-js.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Chart-js.vue"
export default component.exports